import { createIcon } from 'native-base';

export const MessageIcon = () => {
  const CustomIcon = createIcon({
    viewBox: '0 -4 16 28',
    path: [
      <path
        d="M18 0.5H2C0.9 0.5 0 1.4 0 2.5V20.5L4 16.5H18C19.1 16.5 20 15.6 20 14.5V2.5C20 1.4 19.1 0.5 18 0.5Z"
        fill="white"
      />,
    ],
  });
  return <CustomIcon size={6} />;
};
